<template>
  <div class="menus-page">
    <h1 class="display-1">Menus</h1>
    <p>Découvrez l'expérience culinaire au cœur d'Annecy. Notre menu propose une variété de plats exquis, préparés avec des ingrédients frais et de qualité, pour vous offrir une expérience culinaire inoubliable.</p>
    <div class="menu-buttons">
      <div class="menu-buttons-row">
        <a :href="links.carteFr" target="_blank" class="menu-button carte-button">La Carte</a>
        <a :href="links.boissonsFr" target="_blank" class="menu-button boissons-button">Les Boissons</a>
        <a href="https://drive.google.com/file/d/1P96D75Cz_kPhxO4Z5obPyR36BoWu9mqu/view" target="_blank" class="menu-button vins-button">Les Vins</a>
      </div>
      <div class="menu-buttons-row">
        <a :href="links.carteEn" target="_blank" class="menu-button en-button carte-button">Menu</a>
        <a :href="links.boissonsEn" target="_blank" class="menu-button en-button boissons-button">Drinks</a>
        <a href="https://drive.google.com/file/d/1P96D75Cz_kPhxO4Z5obPyR36BoWu9mqu/view" target="_blank" class="menu-button en-button vins-button">Wines</a>
      </div>
    </div>
  </div>
</template>

<script>
// Import avec extension explicite .mjs (robuste quelle que soit la config resolve).
import { fetchPublishedLinks } from '@/lib/publishedMenus.mjs';

// Liens Google Drive de repli : utilisés tant qu'un emplacement n'est pas publié
// depuis l'app, ou si la lecture Firestore échoue.
const FALLBACK = {
  carteFr: 'https://drive.google.com/file/d/1aB6j3kKB0QvOAXtOc0HIerxhJE9_2kAA/view',
  carteEn: 'https://drive.google.com/file/d/1DFjY27EW8r6oEaHf-Mcu8w2TM4cQzSrD/view',
  boissonsFr: 'https://drive.google.com/file/d/18yf2RCqPIMEMUVLAXWEJFsKrNyGuMrVs/view',
  boissonsEn: 'https://drive.google.com/file/d/18yf2RCqPIMEMUVLAXWEJFsKrNyGuMrVs/view',
};

export default {
  name: 'MenusPage',
  data() {
    return { links: { ...FALLBACK } };
  },
  async mounted() {
    const published = await fetchPublishedLinks();
    this.links = { ...FALLBACK, ...published };
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans:ital,wght@0..900;1..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Gotham:wght@100..900&display=swap');

.menus-page {
  padding: 2rem;
  font-family: 'Gotham', sans-serif;
}

.display-1 {
  font-family: 'Fjalla One', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
}

.menu-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.menu-buttons-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.menu-button {
  padding: 0.5rem 1rem;
  border: 2px solid #1a1a1a;
  background-color: #fbecd2;
  color: #1a1a1a;
  text-transform: uppercase;
  font-family: 'Fjalla One', sans-serif;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.menu-button:hover {
  background-color: #1a1a1a;
  color: #fbecd2;
  border-color: #1a1a1a;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

/* Theme colors for menu buttons */
.carte-button {
  background-color: #6f405f;
  color: #fbecd2;
  border-color: #1a1a1a;
}

.carte-button:hover {
  background-color: #5a334d;
  color: #fbecd2;
  border-color: #1a1a1a;
}

.boissons-button {
  background-color: #bd9c59;
  color: #1a1a1a;
  border-color: #1a1a1a;
}

.boissons-button:hover {
  background-color: #a68647;
  color: #fbecd2;
  border-color: #1a1a1a;
}

.vins-button {
  background-color: #652e2a;
  color: #fbecd2;
  border-color: #1a1a1a;
}

.vins-button:hover {
  background-color: #4d2220;
  color: #fbecd2;
  border-color: #1a1a1a;
}

@keyframes scroll {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.subtitle {
  font-family: 'Merriweather Sans', sans-serif;
  font-weight: 300;
  font-style: italic;
}

/* Responsive Styles */
@media (max-width: 1210px) {

  .vertical-text {
    font-size: 2.5em;
  }

  .bigneon{
    font-size: 5em;
  }

  .nav-top {
    height: 3rem;
  }

  h1{
    font-size: 3em;
  }

  h2{
    font-size: 1.6em;
  }

  .nav-link {
    font-size: 0.9rem;
  }

}

@media (max-width: 610px) {
  .nav-side {
    width:3em;
  }

  .nav-top {
    flex-direction: column;
    height: auto;
  }

  .nav-link {
    padding: 0.5rem 0;
  }

  .separator {
    display: none;
  }

  .main-content {
    flex-direction: column;
  }

  .content-text {
    padding: rem;
  }

  .content{
    margin-left: 3em;
  }

  .bigneon {
    font-size: 5rem;
  }

  .lineleft{
    border: none;
  }
  .lineright{
    border: none;
  }
  .linetop{
    border: none;
  }

  .footer {
    flex-direction: column;
    text-align: center;
  }
  .motif{
    display:none;
  }
  .notebas {
    margin-bottom: 5rem;
  }
}
</style>
